export default __webpack_public_path__ + "static/media/bell-ring.482c1707.png";